export default __webpack_public_path__ + "static/media/barIcon_24px.4dc4a8b9.svg";